import { Link } from "react-router-dom";
import { Logo } from "./PeakMark";

const LEGAL_LINKS = [
  { label: "Privacy", to: "/privacy", testId: "footer-link-privacy" },
  { label: "Terms", to: "/terms", testId: "footer-link-terms" },
  { label: "Support", to: "/coacher/support", testId: "footer-link-support" },
  { label: "Contact", href: "mailto:support@buildmakewin.com", testId: "footer-link-contact" },
];

export const Footer = () => (
  <footer className="border-t border-leaf/10 bg-evergreen text-sage" data-testid="footer">
    <div className="mx-auto max-w-[1240px] px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Logo dark />
          <p className="mt-4 max-w-[320px] font-body text-sm leading-relaxed text-sage/80">
            A product company based in Ohio.
          </p>
          <a
            href="mailto:support@buildmakewin.com"
            data-testid="footer-contact-email"
            className="mt-4 inline-block font-body text-sm font-medium text-cream underline underline-offset-4 transition-colors hover:text-white"
          >
            support@buildmakewin.com
          </a>
        </div>
        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-cream">
            Product
          </h3>
          <Link
            to="/coacher"
            data-testid="footer-link-coacher"
            className="mt-4 inline-block font-body text-sm text-sage/90 underline-offset-4 transition-colors hover:text-white hover:underline"
          >
            CoachER
          </Link>
        </div>
        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-cream">
            Company
          </h3>
          <ul className="mt-4 space-y-2.5">
            {LEGAL_LINKS.map((l) => (
              <li key={l.testId}>
                {l.href ? (
                  <a
                    href={l.href}
                    data-testid={l.testId}
                    className="font-body text-sm text-sage/90 underline-offset-4 transition-colors hover:text-white hover:underline"
                  >
                    {l.label}
                  </a>
                ) : (
                  <Link
                    to={l.to}
                    data-testid={l.testId}
                    className="font-body text-sm text-sage/90 underline-offset-4 transition-colors hover:text-white hover:underline"
                  >
                    {l.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <p
        data-testid="footer-legal-notice"
        className="mt-14 border-t border-leaf/10 pt-8 font-body text-xs leading-relaxed text-sage/60"
      >
        © 2026 Build Make Win Ventures LLC. All rights reserved. CoachER is a product of Build Make
        Win Ventures LLC.
      </p>
    </div>
  </footer>
);
